import { Injectable } from '@angular/core';
import { ApiConstants } from '../shared/constants/api.constants';
import { ApiServices } from '../shared/services/api.services';

@Injectable()
export class OtpService {

  private header: Object;

  constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    this.header = {
      'Content-Type': 'application/json',
    };
  }

  verifyOtp(params: any) {
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.verifyOtp.url,
      this.apiConstants.authUrl.verifyOtp.method,
      params,
      null,
      this.header
    );
  }

  generateOtp(params: any) {
    const url = this.apiConstants.authUrl.generateOtp.url;
    return this.apiService.serviceCall(
      url,
      this.apiConstants.authUrl.generateOtp.method,
      params,
      null,
      this.header
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/otp/otp.service.ts